module.exports = __webpack_public_path__ + "static/media/Rubik.c8041f98.ttf";